import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Heading } from '@fiverr-private/typography';

export const HeaderTitle = ({ query }: { query?: string }) => (
    <Heading size="h_lg" fontWeight="normal">
        <I18n k="listings_header.search_header.results_for_query" params={{ query }} />
    </Heading>
);
